<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.66234 15.3662C8.70399 15.9614 10.0001 15.2093 10.0001 14.0095V12.0591L15.7873 15.3662C16.829 15.9614 18.1251 15.2093 18.1251 14.0095L18.1251 7.24049C18.1251 6.04077 16.829 5.28864 15.7873 5.88386L10.0001 9.19088V7.24049C10.0001 6.04077 8.70399 5.28864 7.66234 5.88386L1.73943 9.26838C0.689721 9.86822 0.68972 11.3818 1.73943 11.9816L7.66234 15.3662Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPlayerBack',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>